import React from "react";
import { RouteObject } from "react-router";

// '/user_profile/*'
export const UserProfileRoutes: RouteObject[] = [
  {
    path: "notifications",
    async lazy() {
      const { Notifications } = await import("src/user/Profile/Notifications");
      return { element: <Notifications /> };
    },
  },

  {
    path: "calendar",
    async loader(args) {
      const { calendarOptionsLoader: calendarLoader } = await import("src/router/loaders");
      return calendarLoader(args);
    },
    async lazy() {
      const { CalendarOptions } = await import("src/user/Profile/CalendarOptions");
      return { element: <CalendarOptions /> };
    },
  },
  {
    path: "",
    async lazy() {
      const { GeneralInfo } = await import("src/user/Profile/GeneralInfo");
      return { element: <GeneralInfo /> };
    },
  },
];
